import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LOCALES } from '../seo/site';

import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';
import frTranslations from './locales/fr.json';
import plTranslations from './locales/pl.json';
import itTranslations from './locales/it.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      de: {
        translation: deTranslations
      },
      fr: {
        translation: frTranslations
      },
      pl: {
        translation: plTranslations
      },
      it: {
        translation: itTranslations
      }
    },
    lng: 'en',
    supportedLngs: LOCALES.map(({ code }) => code),
    initImmediate: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 